import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';

import useWindowSize from '#app/hooks/useWindowSize';

import {
  typo_48,
  typo_32,
  typo_24
} from '../../../UI/atoms/typography/typography.module.scss';
import styles from './index.module.scss';

const imgByLocation = (countryCode, images) => {
  switch (countryCode) {
    case 'PE':
      return images[countryCode];
    case 'MX':
      return images[countryCode];
    case 'CO':
      return images[countryCode];
    default:
      return images['US'];
  }
};

const Typography = dynamic(() => import('../../../UI/atoms/typography/typography'));

const Promotion = ({
 title, start, end, images, geolocalizationData 
}) => {
  const [image, setImage] = useState();
  const { isDesktop } = useWindowSize();

  useEffect(() => {
    setImage(
      geolocalizationData && imgByLocation(geolocalizationData.countryCode, images)
    );
  }, [geolocalizationData]);

  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <Typography variant={typo_48} fontWeight={700} tag="h2">
            {title}
          </Typography>
        </div>

        {/* Body */}
        <div className={styles.body}>
          {image && (
            <LazyLoadImage
              effect="blur"
              width={'100%'}
              alt={title}
              src={isDesktop ? image[0] : image[1]}
              threshold={-100}
              placeholder={<Skeleton width="100%" height="100%" />}
            />
          )}
        </div>

        {/* Footer */}
        <div className={styles.footer}>
          <Typography variant={typo_32} fontWeight={700} tag="h2">
            {start}
          </Typography>

          <Typography variant={typo_24} tag="h2">
            {end}
          </Typography>
        </div>
      </div>
    </section>
  );
};

export default Promotion;
